<template>
  <div v-if="showPage403" class="animated content-holder"> 
    <Page403></Page403>
  </div>
  <div v-else class="animated fadeIn">
    <b-card no-body>
      <b-card-header class="custom-header">
        <div><i class="icon-note"></i> Wallet Segement {{ walletSegmentUpdateMode ? " - Edit" : " - New"}}</div>
        <b-button-group>        
            <b-button v-on:click="routerBack()" class="custom-cancel"><i class="fa fa-times text-danger"></i>
                &nbsp;Cancel
            </b-button>
          <b-button v-on:click="post('andClose')" :disabled="submitted"><i class="fa fa-save"></i>&nbsp;Save & Close  </b-button>
        </b-button-group>
      </b-card-header>

      <!-- Modal Component -->
      <div>
        <Modals ref="form"></Modals>
      </div>

      <b-card-body v-if="isLoading">
        <spinner></spinner> 
      </b-card-body>
      <b-card-body v-else class="margin-left-10">
        <b-row>
            <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>
              <b-row>
                <b-col xs="12" lg="12">
                  <b-alert variant="danger"
                    dismissible
                    :show="showErrorAlert"
                    @dismissed="showErrorAlert=false">
                      <div v-html="errorMsg" class="errorMsg"></div>
                  </b-alert>
                  <div v-for="(seg, segIndex) in form.segments" :key="seg.seg_temp_id">
                    <b-col 
                      :md="seg.seg_card_col_md"
                      class="padding-left-0"
                    >    
                      <b-card
                        class="set-card"
                        :name="`seg-card_${seg.seg_temp_id}`"
                        v-show="seg.seg_temp_id"
                        header-tag="header"
                        footer-tag="footer">
                        <div slot="header">
                          {{(!seg.seg_name) ? (segIndex+1) + '. New Segment' : (segIndex+1) + '. ' + seg.seg_name}}
                        </div>
                        <div>
                          <b-row>

                            <b-col 
                              :md="seg.seg_chosenMainTechnologies.length ? '6' : '12'"
                              class="padding-left-0">
                              <b-row>
                                <b-col md="12">
                                  <b-col md="12">
                                    <!-- Create Segment For Wallet -->
                                    <b-form-group
                                      label="Create Segment for Wallet"
                                      label-for="forWallet"
                                      label-class="font-weight-bold pt-0 required"
                                      class="margin-bottom-25"
                                    >
                                      <p>Choose an wallet from the menu to create a segment</p>
                                      <v-select :id="`seg_${seg.seg_temp_id}_segWallet`" 
                                        :name="`seg_${seg.seg_temp_id}_segWallet`"
                                        v-model="seg.seg_wallet" 
                                        :options="existingWallets" 
                                        v-validate="'required'"
                                        data-vv-as="name"
                                        @input="validateObjSegCountWithWalletCount(seg.seg_temp_id)"
                                        :class="{'folder-invalid-border': errors.first(`seg_${seg.seg_temp_id}_segWallet`)}"
                                        placeholder="Choose"
                                        :disabled = "walletSegmentUpdateMode"
                                      >
                                      </v-select>
                                      <b-form-invalid-feedback id="folderLiveFeedback" v-if="errors.has(`seg_${seg.seg_temp_id}_segWallet`)" style="display:block;">
                                        A name is required.
                                      </b-form-invalid-feedback>
                                      <div class="count-info" v-if="seg.seg_wallet">
                                        <span>Wallet Count: <b>{{seg.seg_wallet.walletCount}}</b></span>
                                        <span>Segment(s) used: <b>{{seg.seg_wallet.walletSegmentUsageCountTotal}}</b></span>
                                        <span>Available Count: <b>{{seg.seg_wallet.availableCountForNewWalletSegment}}</b></span> 
                                      </div>
                                    </b-form-group>
                                  </b-col>

                                  <b-col md="12">
                                    <b-row>
                                      <b-col md="6">
                                        <!-- Segment Name -->
                                        <b-form-group
                                          label="Segment Name"
                                          label-for="segmentName"
                                          label-class="font-weight-bold pt-0 required"
                                        > 
                                          <b-form-input id="txtSegName"
                                            type="text"
                                            v-model.lazy.trim="seg.seg_name"
                                            v-validate="{required:true, min:3}"
                                            data-vv-as="name"
                                            :class="{'form-control is-invalid': errors.first(`seg_${seg.seg_temp_id}_segName`) || seg.isWalletSegNameAlreadyTaken}"
                                            :name="`seg_${seg.seg_temp_id}_segName`"
                                            placeholder=""
                                            autocomplete='given-name'
                                            :disabled="walletSegmentUpdateMode"
                                            @keyup="if(seg.isWalletSegNameAlreadyTaken){seg.isWalletSegNameAlreadyTaken=false;}"
                                            autofocus />
                                          <b-form-invalid-feedback  id="setNameLiveFeedback" v-if="errors.has(`seg_${seg.seg_temp_id}_segName`)" style="display:block;">
                                            A name is required & must be at least 3 characters.
                                          </b-form-invalid-feedback>
                                          <b-form-invalid-feedback id="isWalletNameAlreadyTakenLiveFeedback" v-if="seg.isWalletSegNameAlreadyTaken" style="display:block;">
                                            This name is already taken.
                                          </b-form-invalid-feedback>
                                        </b-form-group>
                                      </b-col>
                                      <b-col md="6">
                                        <!-- Segment Alias -->
                                        <b-form-group
                                          label="Alias"
                                          label-for="segmentAlias"
                                          label-class="font-weight-bold pt-0"
                                        > 
                                          <b-form-input id="txtSegAlias"
                                            type="text"
                                            v-model.lazy.trim="seg.seg_alias"
                                            data-vv-as="name"
                                            :name="`seg_${seg.seg_temp_id}_segAlias`"
                                            placeholder=""
                                            :disabled="walletSegmentUpdateMode"
                                            autocomplete='given-name' />
                                        </b-form-group>
                                      </b-col>
                                    </b-row>
                                  </b-col>

                                  <b-col md="12">
                                    <!-- Description -->
                                    <b-form-group
                                      label="Description"
                                      label-for="description"
                                      label-class="font-weight-bold pt-0"
                                    >
                                    <b-form-textarea id="txtDescription" 
                                      class="resize-none"
                                      :rows="5" 
                                      placeholder="Type something"
                                      v-model.lazy.trim="seg.seg_description">
                                    </b-form-textarea>
                                    </b-form-group>

                                    <!-- Segment Count -->
                                    <b-form-group
                                      label="Segment Count"
                                      label-for="segCount"
                                      label-class="font-weight-bold pt-0 required"
                                    >
                                      <b-form-input id="txtSegCount"
                                        type="number"
                                        v-model.lazy.trim="seg.seg_segCount"
                                        v-validate="'required|min_value:1'"
                                        data-vv-as="setCount"
                                        :class="{'form-control is-invalid': errors.first(`seg_${seg.seg_temp_id}_segCount`) || seg.seg_segCountIsGreaterThanWalletAvailableCount}"
                                        :name="`seg_${seg.seg_temp_id}_segCount`"
                                        placeholder=""
                                        min="1"
                                        @keyup="validateObjSegCountWithWalletCount(seg.seg_temp_id)"
                                        @blur="validateObjSegCountWithWalletCount(seg.seg_temp_id)"
                                        />
                                      <b-form-invalid-feedback id="setCountLiveFeedback" v-if="errors.has(`seg_${seg.seg_temp_id}_segCount`)" style="display:block;">
                                        Count is required and minimum is 1.
                                      </b-form-invalid-feedback>
                                      <b-form-invalid-feedback id="setCountLiveFeedback" v-if="seg.seg_segCountIsGreaterThanWalletAvailableCount" style="display:block;">
                                        Value should not be greater than the Available Count.
                                      </b-form-invalid-feedback>

                                      <b-form-invalid-feedback id="setCountLiveFeedback" v-if="walletSegmentUpdateMode && updateCountIsLessThanOriginalSegCount" style="display:block;">
                                        {{updateCountIsLessThanOriginalSegCount_Msg}}
                                      </b-form-invalid-feedback>
                                    </b-form-group>
                                    <!-- Points Value -->
                                    <b-form-group
                                      label="Points Value"
                                      label-for="pointsValue"
                                      label-class="font-weight-bold pt-0"
                                    >
                                      <b-form-input id="txtPointsValue"
                                        type="number"
                                        disabled
                                        v-model.lazy.trim="seg.seg_segPointsValue"
                                        data-vv-as="pointsValue"
                                        :name="`seg_${seg.seg_temp_id}_pointsValue`"
                                        placeholder=""
                                        min="1"
                                        />
                                    </b-form-group>
                                        
                                  </b-col>
                                  <b-col md="12">
                                    <!-- Choose Main Technology -->
                                    <b-form-group
                                      label="Choose Main Technology"
                                      label-for="description"
                                      label-class="font-weight-bold pt-0 required"
                                    >
                                    <div 
                                      class="custom-control custom-checkbox custom-control-inline"
                                      v-for="mainTech in seg.seg_mainTechnologies" :key="mainTech.techProductName"
                                    >
                                      <input type="checkbox" 
                                        class="custom-control-input" 
                                        :id="`seg_${seg.seg_temp_id}_chk_${mainTech.techProductName}`"
                                        :name="`seg_${seg.seg_temp_id}_chk_${mainTech.techProductName}`"
                                        v-validate="{required:true}"
                                        :checked="mainTech.checked"
                                        :disabled="mainTech.disabled"
                                        @change="selectMainTech(seg.seg_temp_id)"
                                        v-model="mainTech.checked">
                                      <label class="custom-control-label padding-top-1" 
                                        :for="`seg_${seg.seg_temp_id}_chk_${mainTech.techProductName}`"
                                        :id="`seg_${seg.seg_temp_id}_label_${mainTech.techProductName}`"
                                        :title="mainTech.full_title != 'NULL' ? mainTech.full_title : ''"
                                      >
                                        <i v-if="mainTech.icon_class != 'NULL'"
                                          :class="mainTech.icon_class"
                                        ></i>
                                        <img v-if="mainTech.icon_image != 'NULL'"
                                          :src="mainTech.icon_image"
                                          class="tech-image"
                                        />
                                        {{mainTech.title}}
                                      </label>
                                      <!--<b-popover :target="`seg_${seg.seg_temp_id}_label_${mainTech.techProductName}`" placement="top" triggers="hover focus" v-if="mainTech.full_title != 'NULL'">
                                        {{mainTech.full_title}}
                                      </b-popover>-->
                                    </div>

                                    <b-form-input id="txtMainTechSelectionStatusHidden"
                                      type="text"
                                      hidden
                                      v-validate="'main_tech_selection_status_validate'"
                                      v-model.lazy.trim="seg.main_tech_selection_status"
                                      :name="`seg_${seg.seg_temp_id}_main_tech_selection_status`"
                                    />
                                    <b-form-invalid-feedback v-if="errors.has(`seg_${seg.seg_temp_id}_main_tech_selection_status`)" id="folderLiveFeedback" style="display:block;">
                                      At least 1 selection of main technology is required.
                                    </b-form-invalid-feedback>
                                    </b-form-group>
                                    <!-- Choose Sub Technology -->
                                    <b-form-group
                                      label="Choose Sub Technology if any"
                                      label-for="description"
                                      label-class="font-weight-bold pt-0"
                                    >
                                    <div 
                                      class="custom-control custom-checkbox custom-control-inline"
                                      v-for="subTech in seg.seg_subTechnologies" :key="subTech.techProductName"
                                    >
                                      <input type="checkbox" 
                                        class="custom-control-input" 
                                        :id="`seg_${seg.seg_temp_id}_chk_${subTech.techProductName}`"
                                        :name="`seg_${seg.seg_temp_id}_chk_${subTech.techProductName}`"
                                        :checked="subTech.checked"
                                        :disabled="subTech.disabled"
                                        @change="selectSubTech(seg.seg_temp_id)"
                                        v-model="subTech.checked">
                                      <label class="custom-control-label" 
                                        :for="`seg_${seg.seg_temp_id}_chk_${subTech.techProductName}`"
                                        :id="`seg_${seg.seg_temp_id}_label_${subTech.techProductName}`"
                                        :title="subTech.full_title != 'NULL' ? subTech.full_title : ''"
                                      >
                                        <i v-if="subTech.icon_class != 'NULL'"
                                          :class="subTech.icon_class"
                                        ></i>
                                        <img v-if="subTech.icon_image != 'NULL'"
                                          :src="subTech.icon_image"
                                          class="tech-image"
                                        />
                                        {{subTech.title}}
                                      </label>
                                      <!--<b-popover :target="`seg_${seg.seg_temp_id}_label_${subTech.techProductName}`" placement="top" triggers="hover focus" v-if="subTech.full_title != 'NULL'">
                                        {{subTech.full_title}}
                                      </b-popover>-->
                                    </div>
                                    </b-form-group> 

                                    <!-- Active Value -->
                                    <b-form-group
                                      v-if="walletSegmentUpdateMode"
                                      label="Active"
                                      label-for="active"
                                      label-class="font-weight-bold pt-0"
                                    >
                                      <c-switch class="mx-1" data-on="" data-off="" dataOn="" dataOff="" color="success" :checked="seg.seg_active" label v-model.lazy="seg.seg_active"/>
                                    </b-form-group>

                                    <!-- Published Value -->
                                    <b-form-group
                                      v-if="walletSegmentUpdateMode"
                                      label="Published"
                                      label-for="published"
                                      label-class="font-weight-bold pt-0"
                                    >
                                      <c-switch class="mx-1" data-on="" data-off="" dataOn="" dataOff="" color="success" :checked="seg.seg_published" label v-model.lazy="seg.seg_published"/>
                                    </b-form-group>
                                  </b-col>

                                </b-col>
                              </b-row>
                            </b-col>
                            
                            
                            <b-col 
                              md="6" 
                              class="padding-left-0 techs-config"
                              v-if="seg.seg_chosenMainTechnologies.length" >
                                
                              <b-form-group
                                label="Techs Configuration"
                                label-for="walletName"
                                label-class="font-weight-bold pt-0 required"
                              > 
                              </b-form-group>
                              <p>Configure the techs to generate</p>
                              
                              
                              <b-card no-body>
                                <b-tabs card pills vertical nav-wrapper-class="w-40" >
                                  <b-tab v-for="chosenMainTech in seg.seg_chosenMainTechnologies" :key="chosenMainTech.main_techId">
                                    <template slot="title">
                                      {{chosenMainTech.main_techProductTitle}}
                                    </template>
                                    <b-col>
                                      <!-- Generate QR codes -->
                                      <div
                                        class="custom-control custom-checkbox custom-control-inline"
                                        v-if="chosenMainTech.main_techProductName=='qr'"
                                      >
                                        <input type="checkbox" :id="`seg_${seg.seg_temp_id}_techConfigs_qr_generateQR`" 
                                            :name="`seg_${seg.seg_temp_id}_techConfigs_qr_generateQR`"
                                          class="custom-control-input" 
                                          :checked="chosenMainTech.tech_configs.generate_qr"
                                          v-model="chosenMainTech.tech_configs.generate_qr"
                                          :disabled="walletSegmentUpdateMode && walletSeg_DBData != null && !!walletSeg_DBData.chosenMainTechsAndConfigs.find(chosenMainTech => chosenMainTech.main_techProductName == 'qr') == true"
                                          >
                                        <label class="custom-control-label" 
                                          :for="`seg_${seg.seg_temp_id}_techConfigs_qr_generateQR`"
                                        >
                                          Generate QR codes
                                        </label>
                                      </div>
                                    </b-col>
                                    <b-col class="margin-top-10">
                                      <!-- Create images for QR codes -->
                                      <div 
                                        class="custom-control custom-checkbox custom-control-inline"
                                        v-if="chosenMainTech.main_techProductName=='qr'"
                                      >
                                        <input type="checkbox" :id="`seg_${seg.seg_temp_id}_techConfigs_qr_createQRImages`" 
                                          :name="`seg_${seg.seg_temp_id}_techConfigs_qr_createQRImages`"
                                          class="custom-control-input" 
                                          :checked="chosenMainTech.tech_configs.create_qr_images"
                                          v-model="chosenMainTech.tech_configs.create_qr_images"
                                          :disabled="walletSegmentUpdateMode && walletSeg_DBData != null && !!walletSeg_DBData.chosenMainTechsAndConfigs.find(chosenMainTech => chosenMainTech.main_techProductName == 'qr') == true"
                                          >
                                        <label class="custom-control-label" 
                                          :for="`seg_${seg.seg_temp_id}_techConfigs_qr_createQRImages`"
                                        >
                                          Create images for QR codes
                                        </label>
                                      </div>
                                    </b-col>
                                  </b-tab>
                                  <b-tab v-for="chosenSubTech in seg.seg_chosenSubTechnologies" :key="chosenSubTech.sub_techId">
                                    <template slot="title">
                                      {{chosenSubTech.sub_techProductTitle}}
                                    </template>
                                    <div v-if="chosenSubTech.sub_techProductName=='protect_code'">
                                      <!-- Protect-Code Formats -->
                                      <b-form-group
                                        label="Code Format"
                                        label-class="font-weight-bold pt-0 required"
                                        class="margin-bottom-25"
                                        :disabled="walletSegmentUpdateMode && walletSeg_DBData != null && !!walletSeg_DBData.chosenSubTechsAndConfigs.find(chosenSubTech => chosenSubTech.sub_techProductName == 'protect_code') == true"
                                      > 
                                        <b-form-select :id="`seg_${seg.seg_temp_id}_techConfigs_protectCode_codeFormat`" 
                                          :name="`seg_${seg.seg_temp_id}_techConfigs_protectCode_codeFormat`"
                                          v-model="chosenSubTech.tech_configs.code_format" 
                                          :options="protect_codeFormats"
                                          placeholder="Choose" 
                                        >
                                        </b-form-select>
                                      </b-form-group>
                                      <!-- Exclude Similar -->
                                      <b-form-group
                                        label="Exclude"
                                        label-class="font-weight-bold pt-0"
                                        class="margin-bottom-25"
                                        :disabled="walletSegmentUpdateMode && walletSeg_DBData != null && !!walletSeg_DBData.chosenSubTechsAndConfigs.find(chosenSubTech => chosenSubTech.sub_techProductName == 'protect_code') == true"
                                      >
                                        <div
                                          class="custom-control custom-checkbox custom-control-inline"
                                        >
                                          <input type="checkbox" :id="`seg_${seg.seg_temp_id}_techConfigs_protectCode_excludeSimilar`" 
                                              :name="`seg_${seg.seg_temp_id}_techConfigs_protectCode_excludeSimilar`"
                                            class="custom-control-input" 
                                            :checked="chosenSubTech.tech_configs.exclude_similar"
                                            v-model="chosenSubTech.tech_configs.exclude_similar"
                                            >
                                          <label class="custom-control-label"
                                            :for="`seg_${seg.seg_temp_id}_techConfigs_protectCode_excludeSimilar`"
                                          >
                                            Exclude similar (i, l, 1, L, o, O, 0)
                                          </label>
                                        </div>
                                      </b-form-group>
                                      <!-- Include Symbols -->
                                      <b-form-group
                                        label="Include"
                                        label-class="font-weight-bold pt-0"
                                        class="margin-bottom-25"
                                        :disabled="walletSegmentUpdateMode && walletSeg_DBData != null && !!walletSeg_DBData.chosenSubTechsAndConfigs.find(chosenSubTech => chosenSubTech.sub_techProductName == 'protect_code') == true"
                                      >
                                        <div
                                          class="custom-control custom-checkbox custom-control-inline"
                                        >
                                          <input type="checkbox" :id="`seg_${seg.seg_temp_id}_techConfigs_protectCode_includeSymbols`" 
                                              :name="`seg_${seg.seg_temp_id}_techConfigs_protectCode_includeSymbols`"
                                            class="custom-control-input" 
                                            :checked="chosenSubTech.tech_configs.include_symbols"
                                            v-model="chosenSubTech.tech_configs.include_symbols"
                                            >
                                          <label class="custom-control-label" 
                                            :for="`seg_${seg.seg_temp_id}_techConfigs_protectCode_includeSymbols`"
                                          >
                                            Include Symbols (@#$%)
                                          </label>
                                        </div>
                                      </b-form-group>
                                      <!-- Character Length -->
                                      <b-form-group
                                        label="Character Length"
                                        label-class="font-weight-bold pt-0"
                                        class="margin-bottom-25"
                                        :disabled="walletSegmentUpdateMode && walletSeg_DBData != null && !!walletSeg_DBData.chosenSubTechsAndConfigs.find(chosenSubTech => chosenSubTech.sub_techProductName == 'protect_code') == true"
                                      >
                                        <div
                                          class="custom-control custom-checkbox custom-control-inline"
                                        >
                                          <input type="checkbox" :id="`seg_${seg.seg_temp_id}_techConfigs_protectCode_fixedLength`" 
                                            :name="`seg_${seg.seg_temp_id}_techConfigs_protectCode_fixedLength`"
                                            class="custom-control-input" 
                                            :checked="chosenSubTech.tech_configs.fixed_length"
                                            v-model="chosenSubTech.tech_configs.fixed_length"
                                            >
                                          <label class="custom-control-label" 
                                            :for="`seg_${seg.seg_temp_id}_techConfigs_protectCode_fixedLength`"
                                          >
                                            Fixed Length
                                          </label>
                                        </div>
                                      </b-form-group>

                                      <div class="mini-max-length-controls" v-show="!chosenSubTech.tech_configs.fixed_length">
                                        <!-- Minimum Length -->
                                        <b-form-group
                                          label="Minimum Length"
                                          label-for="minimumLength"
                                          label-class="font-weight-bold pt-0"
                                        >
                                          <b-form-input :id="`seg_${seg.seg_temp_id}_techConfigs_protectCode_minimumCharacterLength`" 
                                            :name="`seg_${seg.seg_temp_id}_techConfigs_protectCode_minimumCharacterLength`"
                                            type="number"
                                            v-model.lazy.trim="chosenSubTech.tech_configs.min_character_length"
                                            v-validate="!chosenSubTech.tech_configs.fixed_length ? 'required' : ''"
                                            data-vv-as="setCount"
                                            :class="{'form-control is-invalid': !chosenSubTech.tech_configs.fixed_length && errors.first(`seg_${seg.seg_temp_id}_techConfigs_protectCode_minimumCharacterLength`)}"
                                            placeholder=""
                                            min="1"
                                            :disabled="walletSegmentUpdateMode && walletSeg_DBData != null && !!walletSeg_DBData.chosenSubTechsAndConfigs.find(chosenSubTech => chosenSubTech.sub_techProductName == 'protect_code') == true"
                                            />
                                          <b-form-invalid-feedback id="setCountLiveFeedback" v-if="!chosenSubTech.tech_configs.fixed_length && errors.has(`seg_${seg.seg_temp_id}_techConfigs_protectCode_minimumCharacterLength`)" style="display:block;">
                                            This is required.
                                          </b-form-invalid-feedback>
                                        </b-form-group>
                                        <!-- Maximum Length -->
                                        <b-form-group
                                          label="Maximum Length"
                                          label-for="maximumLength"
                                          label-class="font-weight-bold pt-0"
                                          
                                        >
                                          <b-form-input :id="`seg_${seg.seg_temp_id}_techConfigs_protectCode_maximumCharacterLength`" 
                                            :name="`seg_${seg.seg_temp_id}_techConfigs_protectCode_maximumCharacterLength`"
                                            type="number"
                                            v-model.lazy.trim="chosenSubTech.tech_configs.max_character_length"
                                            v-validate="!chosenSubTech.tech_configs.fixed_length ? 'required' : ''"
                                            data-vv-as="setCount"
                                            :class="{'form-control is-invalid': !chosenSubTech.tech_configs.fixed_length && errors.first(`seg_${seg.seg_temp_id}_techConfigs_protectCode_maximumCharacterLength`)}"
                                            placeholder=""
                                            min="1"
                                            :disabled="walletSegmentUpdateMode && walletSeg_DBData != null && !!walletSeg_DBData.chosenSubTechsAndConfigs.find(chosenSubTech => chosenSubTech.sub_techProductName == 'protect_code') == true"
                                            />
                                          <b-form-invalid-feedback id="setCountLiveFeedback" v-if="!chosenSubTech.tech_configs.fixed_length && errors.has(`seg_${seg.seg_temp_id}_techConfigs_protectCode_maximumCharacterLength`)" style="display:block;">
                                            This is required.
                                          </b-form-invalid-feedback>
                                        </b-form-group>

                                      </div>

                                      <div class="mini-max-length-controls" v-show="chosenSubTech.tech_configs.fixed_length">
                                        
                                        <!-- Fixed Length -->
                                        <b-form-group
                                          label="Length"
                                          label-for="length"
                                          label-class="font-weight-bold pt-0"
                                        >
                                          <b-form-input :id="`seg_${seg.seg_temp_id}_techConfigs_protectCode_fixedCharacterLength`" 
                                            :name="`seg_${seg.seg_temp_id}_techConfigs_protectCode_fixedCharacterLength`"
                                            type="number"
                                            v-model.lazy.trim="chosenSubTech.tech_configs.fixed_character_length"
                                            v-validate="chosenSubTech.tech_configs.fixed_length ? 'required' : ''"
                                            data-vv-as="setCount"
                                            :class="{'form-control is-invalid': chosenSubTech.tech_configs.fixed_length && errors.first(`seg_${seg.seg_temp_id}_techConfigs_protectCode_fixedCharacterLength`)}"
                                            placeholder=""
                                            min="1"
                                            :disabled="walletSegmentUpdateMode && walletSeg_DBData != null && !!walletSeg_DBData.chosenSubTechsAndConfigs.find(chosenSubTech => chosenSubTech.sub_techProductName == 'protect_code') == true"
                                            />
                                          <b-form-invalid-feedback id="setCountLiveFeedback" v-if="chosenSubTech.tech_configs.fixed_length && errors.has(`seg_${seg.seg_temp_id}_techConfigs_protectCode_fixedCharacterLength`)" style="display:block;">
                                            This is required.
                                          </b-form-invalid-feedback>
                                        </b-form-group>

                                      </div>

                                    </div>
                                  </b-tab>
                                </b-tabs>                    
                              </b-card>
                            </b-col>
                          </b-row>     
                        </div>
                        <div slot="footer" v-if="!walletSegmentUpdateMode">
                          <b-button variant="outline-secondary" v-on:click="removeSegment(seg.seg_temp_id)">
                            <i class="fa fa-trash"></i>&nbsp;Remove
                          </b-button>
                        </div>
                      </b-card>
                    </b-col>
                  </div>
                  <b-button variant="outline-primary" v-if="!walletSegmentUpdateMode" v-on:click="addSegment()">
                    <i class="fa fa-plus"></i>&nbsp;Add Segment
                  </b-button>
                  <b-button hidden variant="outline-primary" v-on:click="testSegArray()">
                    <i class="fa fa-plus"></i>&nbsp;Test Segment Array
                  </b-button>
                  <b-button hidden variant="outline-primary" v-on:click="testValidate()">
                    <i class="fa fa-plus"></i>&nbsp;Validate
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
            <br/>
         
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import Vue from 'vue';
import uuid from "uuid";
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import { router } from '../../router/index';
import { mapState, mapActions } from 'vuex';
import VueNotifications from 'vue-notifications';
import miniToastr from 'mini-toastr';
import { apigClient } from '@/shared/api';
import { parenthesizedExpression } from '@babel/types';
import { resolve } from 'url';
import Modals from "@/shared/Modals.vue";
import Page403 from "@/views/pages/Page403.vue";

const Spinner = () => import('../shared/Spinner');

const protect_codeFormats = [
  { value: 'alpha', text: 'Alpha' },
  { value: 'numeric', text: 'Numeric' },
  { value: 'alpha-numeric', text: 'Alpha-Numeric' },
]


const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}
miniToastr.init({types: toastTypes})
function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

Vue.use(VueNotifications, options);

export default {
  name: "Wallet",
  components: {
    vSelect,
    cSwitch,
    Spinner,
    Modals,
    Page403
  },
  data() {
    // check route here, new or edit
    let newModePage = true;
    if(window.location.href.includes("/wallet-segments/edit")){
      var page_wallet_segment_id = localStorage.getItem('page_wallet_segment_id');
      newModePage = false;
    }
    return {
      loginUserInfo: JSON.parse(localStorage.getItem('loginUserInfo')),
      permission: {
        permissionBaseName: null,
        permissionBaseNameCapabilities: null,
        capabilities: {
          View: false,
          Edit: false,
          Delete: false,
          Create: false,
        }
      },
      showPage403: false,
      newModePage: newModePage,
      existingWallets: [],
      currentTab: 'Details',
      allTechs: [], 
      mainTechs: [],
      subTechs: [],
      form: {
        segments: [],
      },
      validationTabs: {
        detailsTabValidationPass: true,
        setTabValidationPass: true,
        techTabValidationPass: true
      },
      protect_codeFormats: protect_codeFormats,
      feedBack: 'secondary',
      submitted: false,
      page_wallet_segment_id: page_wallet_segment_id || null,
      walletSeg_DBData: null,
      disabled: true,
      isLoading: true,
      showErrorAlert: false,
      errorMsg: '',
      walletSegmentUpdateMode: (page_wallet_segment_id) ? true : false,
      updateCountIsLessThanOriginalSegCount: false,
      updateCountIsLessThanOriginalSegCount_Msg: ""
    }
  },
  watch:{
  },
  created: function() {
    this.$validator.extend('main_tech_selection_status_validate', {
      //getMessage: field => 'At least one ' + field + ' needs to be checked.',
      validate: (value) => {
        return (value == 'one_main_tech_checked');
      }
    });
  },
  mounted: function(){
    let that = this;
    that.getPermission();
    if(that.newModePage && !that.permission.capabilities.Create){
      that.showPage403 = true;
      return;
    } else if ( !that.newModePage && !that.permission.capabilities.Edit){
      that.showPage403 = true;
      return;
    }

    if ( that.page_wallet_segment_id ){
      //this.getUserData();
      that.getTechProductsData();
      that.loadObjectsToDropdownList();
    } else {
      that.isLoading = false;
      that.getTechProductsData();
      that.loadObjectsToDropdownList();
    }
  },
  computed: {
    isValid() {
      // Check errors count to determine valid or not
      return this.errors.count() <= 0
    }
    
  },
  methods: {
    getPermission(){
      let that = this;
      const userPermissionsBasedOnEntity = that.loginUserInfo.db.userPermissionsBasedOnEntity;
      if(this.$route.meta && userPermissionsBasedOnEntity){
        that.permission.permissionBaseName = this.$route.meta.permissionBaseName;
        let userPermissionBasedOnEntity = userPermissionsBasedOnEntity.find(p => p.permissionBaseName === this.$route.meta.permissionBaseName);
        if(userPermissionBasedOnEntity){
          that.permission.permissionBaseNameCapabilities = userPermissionBasedOnEntity.capabilities;
          that.permission.permissionBaseNameCapabilities.forEach(capability=>{
            that.permission.capabilities[capability.label] = capability.value
          });
        } 
      } else{
        router.push('/no-permission-given');
      }
      console.log('permission: ' , that.permission);
    },
    getWalletSegmentData(walletSegmentId) {
      console.log(walletSegmentId);
      var method = 'GET';
      var pathTemplate = '/wallet-segments/' + walletSegmentId;
      var additionalParams ={};
      var pathParams = {};
      var userData = [];
      let that = this;
      
      //self.isLoading = true;
      apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result){
          that.walletSeg_DBData = result["data"]["data"];
          console.log(that.walletSeg_DBData);

          var walletSeg_FromDB = JSON.parse(JSON.stringify(result["data"]["data"]));

          console.log('walletSeg_FromDB', walletSeg_FromDB);

          if(walletSeg_FromDB.id){
            let objSegment = that.form.segments[0];
            console.log(objSegment);

            let selectedWallet = that.existingWallets.find(o => o.value === walletSeg_FromDB.wallet_id);
            if(selectedWallet){
              objSegment.seg_wallet = selectedWallet;
            }
            objSegment.seg_name = walletSeg_FromDB.walletSegmentName;
            objSegment.seg_alias = walletSeg_FromDB.alias;
            objSegment.seg_description = (walletSeg_FromDB.description == "NULL") ? "" : walletSeg_FromDB.description;
            objSegment.seg_segCount = walletSeg_FromDB.segmentCount;
            objSegment.seg_active = walletSeg_FromDB.active;
            objSegment.seg_published = walletSeg_FromDB.published;

            // objSegment.seg_mainTechnologies = walletSeg_FromDB.chosenMainTechsAndConfigs;
            // objSegment.seg_subTechnologies = walletSeg_FromDB.chosenSubTechsAndConfigs;

            console.log(objSegment.seg_subTechnologies);
            // Auto-select saved Main Tech and its config
            walletSeg_FromDB.chosenMainTechsAndConfigs.forEach((chosenMainTech) => {
              let mainTechToSelect= objSegment.seg_mainTechnologies.find(s => s.id == chosenMainTech.main_techId);
              if(mainTechToSelect != null && mainTechToSelect != undefined){
                mainTechToSelect.checked = true;
                mainTechToSelect.disabled = true;
                that.selectMainTech(objSegment.seg_temp_id);
              }
            });
            objSegment.seg_chosenMainTechnologies = walletSeg_FromDB.chosenMainTechsAndConfigs;

            // Auto-select saved Sub Techs and its config
            walletSeg_FromDB.chosenSubTechsAndConfigs.forEach((chosenSubTech) => {
              let subTechToSelect= objSegment.seg_subTechnologies.find(s => s.id == chosenSubTech.sub_techId);
              if(subTechToSelect != null && subTechToSelect != undefined){
                subTechToSelect.checked = true;
                subTechToSelect.disabled = true;
                that.selectSubTech(objSegment.seg_temp_id);
              }
            });
            objSegment.seg_chosenSubTechnologies = walletSeg_FromDB.chosenSubTechsAndConfigs;

            that.isLoading = false;
          } else{
            that.showItemNotExitsInfoMsg();
            that.$router.push({ path: '/wallet-segments/list' });
          }
    
          //This is where you would put a success callback
          that.isLoading = false;
        }).catch( function(error){
          console.log('ERROR ! Cannot get data:' + error);
          that.isLoading = false;
          //This is where you would put an error callback
        });
    },
    checkWalletSegNamesAreAlreadyTaken(){
      let that = this;
      return new Promise((resolve, reject) => {
        let segsToPass=that.form.segments.map(seg => {
          return {
            seg_temp_id: seg.seg_temp_id,
            seg_name: seg.seg_name,
            isWalletSegNameAlreadyTaken: false,
            seg_wallet_companyId: seg.seg_wallet.companyInfo.id
          }
        });
        if(segsToPass.length>=1){
          let body = {
            walletSegments: segsToPass
          }
          apigClient
            .invokeApi({}, '/wallet-segments/validate-names', "POST", {}, body)
            .then(function(result) {
              console.log(result)
              if (result.data.status) {
                let checkedWalletSegs = result.data.data;
                if(checkedWalletSegs.length>=1){
                  checkedWalletSegs.forEach((checkedSeg)=>{
                    let formSeg = that.form.segments.find(formSeg => formSeg.seg_temp_id == checkedSeg.seg_temp_id);
                    if(formSeg){
                      formSeg.isWalletSegNameAlreadyTaken = checkedSeg.isWalletSegNameAlreadyTaken;
                    }
                  });
                }
                resolve('success');
              } else {
                console.log(`Cannot check Wallet Seg Name(s) duplication against db. Error found from API Endpoint: ${result.data.message}`);
                that.errorMsg = '<p>Cannot check Wallet Seg Name(s) duplication against db. See console for details</p>';
                that.showErrorAlert = true;
                reject('error');
              }
            })
            .catch(function(error) {
              console.log('Cannot check Wallet Seg Name(s) duplication against db. ERROR:' + error);
              that.errorMsg = '<p>Cannot check Wallet Seg Name(s) duplication against db. See console for details</p>';
              that.showErrorAlert = true;
              reject('error');
            });
          }else{
            reject('error');
          }
      });
    },
    validateObjSegCountWithWalletCount(seg_temp_id){
      var that = this;
      let segment = that.form.segments.find(s=> s.seg_temp_id === seg_temp_id);

      // Let's validate for update mode
      // Update mode, validate not to let decrease the previous segment count
      if(that.walletSegmentUpdateMode && that.walletSeg_DBData != null && that.walletSeg_DBData != undefined){
        if(parseInt(segment.seg_segCount) < parseInt(that.walletSeg_DBData.segmentCount)){
          that.updateCountIsLessThanOriginalSegCount = true;
          that.updateCountIsLessThanOriginalSegCount_Msg = "Value should not be less than Original Segment Count (" + that.walletSeg_DBData.segmentCount + ")";
        } else{
          that.updateCountIsLessThanOriginalSegCount = false;
          that.updateCountIsLessThanOriginalSegCount_Msg = "";
        }
      }

      if(segment && segment.seg_wallet != null){
        if(parseInt(segment.seg_segCount) > parseInt(segment.seg_wallet.availableCountForNewWalletSegment)) {
          console.log(segment.seg_segCount + ' > ' +  segment.seg_wallet.availableCountForNewWalletSegment);
          segment.seg_segCountIsGreaterThanWalletAvailableCount = true;
        } else {
          segment.seg_segCountIsGreaterThanWalletAvailableCount = false;
        }
      }
    },
    testValidate(){
      this.$validator.validateAll();
    },
    /**
     * Load Id and Name of Wallets into existingWallets[] that is binded with For Company dropdown.
    */
    loadObjectsToDropdownList: async function() {
      let that = this;
      let method = 'GET';
      let pathTemplate = '/wallets';
      let params = {includeCompanyInfo: true};
      params.filter = [];
      if(that.loginUserInfo.db.roleName!='Admin'){
        params.filter = [
          {
            fieldname: "company_id",
            comparisonOperator: "=",
            value: that.loginUserInfo.db.company.id
          }
        ]
      }
      params.filter.push({
        fieldname: "isDeleted",
        comparisonOperator: "=",
        value: false
      });
      let additionalParams ={
        queryParams: {
          params: JSON.stringify(params)
        }
      };
      let pathParams = {};
      await apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
      .then(function(result){
        if (result.data.status) {
          result["data"]["data"].forEach((wallet, index) => { 
            that.existingWallets.push({
              value: wallet.id,
              label: wallet.walletName,
              walletName: wallet.walletName,
              walletCount: wallet.walletCount,
              walletSegmentUsageCountTotal: wallet.walletSegmentUsageCountTotal,
              availableCountForNewWalletSegment: (parseInt(wallet.walletCount) - parseInt(wallet.walletSegmentUsageCountTotal)),
              companyInfo: wallet.companyInfo
            });
            console.log(that.existingWallets)
          });

          if(that.walletSegmentUpdateMode){
            that.getWalletSegmentData(that.page_wallet_segment_id);
          }
        } else{
          console.log(`Error found from API Endpoint: ${result.data.message}`);
        }
      }).catch( function(error){
        console.log('ERROR ! Cannot get data:' + error);
      });
    },
    selectMainTech(seg_temp_id){
      var that = this;
      let segment = that.form.segments.find(s => s.seg_temp_id == seg_temp_id);
      if(segment != null){
        let selectedMainTechIndex = segment.seg_mainTechnologies.findIndex(s => s.checked == true);
        console.log(selectedMainTechIndex);
        if(selectedMainTechIndex >= 0){
          console.log(selectedMainTechIndex);
          // There is one Main Tech selected, so, change the status
          segment.main_tech_selection_status = 'one_main_tech_checked';

          let selectedMainTech_AvailableSubTechs = null;        
          segment.seg_mainTechnologies.forEach((mainTech, mainTechIndex) =>{
            if(mainTechIndex == selectedMainTechIndex){
              // Get selectedMainTech_AvailableSubTechs
              selectedMainTech_AvailableSubTechs = mainTech.available_sub_techs;

              // Save to chosen Main Tech list if it is not yet existed
              let existingChosenMainTechIndex = segment.seg_chosenMainTechnologies.findIndex(s => s.main_techId == mainTech.id);
              console.log(mainTech)
              if(existingChosenMainTechIndex <= -1){
                segment.seg_chosenMainTechnologies.push({
                  main_techId: mainTech.id,
                  main_techProductName: mainTech.techProductName,
                  main_techProductTitle: mainTech.title,
                  tech_configs: !mainTech.tech_configs ? null : mainTech.tech_configs
                });
              }
            }else{
              // Deselect and Disable Other Main techs
              mainTech.checked = false;
              mainTech.disabled = true;
            }
          });

          // let's enable available sub tech of selected main tech
          segment.seg_subTechnologies.forEach((subTech) => {
            if(selectedMainTech_AvailableSubTechs != null){
              // enable available sub techs
              if(selectedMainTech_AvailableSubTechs.indexOf(subTech.id) > -1){
                subTech.checked = false;
                subTech.disabled = false;
              } else{
                // deselect and disable unavailabe sub techs
                subTech.checked = false;
                subTech.disabled = true;
              }
            }
          });
        } else{
            console.log('At leas One Main Tech not checked')
            segment.main_tech_selection_status = 'not_one_main_tech_checked';
            // SelectedMainTech become unselected, enable the others
            segment.seg_mainTechnologies.forEach((mainTech) =>{
              mainTech.checked = false;
              mainTech.disabled = false;
            });
            segment.seg_subTechnologies.forEach((subTech) =>{
              subTech.checked = false;
              subTech.disabled = true;
            });

            // Reset chosen main tech and sub tech list
            segment.seg_chosenMainTechnologies = [];
            segment.seg_chosenSubTechnologies = [];
          }

          console.log(segment.seg_chosenMainTechnologies)
          that.determineSegmentsCardsColSize();
      }
    },
    selectSubTech(seg_temp_id){
      var that = this;
      let segment = that.form.segments.find(s => s.seg_temp_id == seg_temp_id);
      if(segment != null){
        segment.seg_subTechnologies.forEach((subTech) =>{
          let existingChosenSubTechIndex = segment.seg_chosenSubTechnologies.findIndex(s => s.sub_techId == subTech.id);
          if(!subTech.disabled && subTech.checked){
            // Save to chosen Sub Tech list if it is not yet existed
            if(existingChosenSubTechIndex <= -1){
              segment.seg_chosenSubTechnologies.push({
                sub_techId: subTech.id,
                sub_techProductName: subTech.techProductName,
                sub_techProductTitle: subTech.title,
                tech_configs: !subTech.tech_configs ? null : subTech.tech_configs
              });
            }
          }
          else if(!subTech.disabled && !subTech.checked){
            // Remove from chosen Sub Tech list if it is unchecked
            if(existingChosenSubTechIndex > -1){
              segment.seg_chosenSubTechnologies.splice(existingChosenSubTechIndex, 1);
            }
          }
        });
      }
    },
    determineSegmentsCardsColSize(){
      var that = this;
      let segsThatHasChosenMainTech = [];
      // Getting to know which seg has main tech chosen
      that.form.segments.forEach((seg) => {
        if(seg.seg_chosenMainTechnologies.length){
          segsThatHasChosenMainTech.push(seg.seg_temp_id);
        }
      });

      // Loop the segments and change the segment card Col size
      if(segsThatHasChosenMainTech.length){
        that.form.segments.forEach((seg) => {
          if(segsThatHasChosenMainTech.indexOf(seg.seg_temp_id) <= -1){
            seg.seg_card_col_md = "7";
          } else {
            seg.seg_card_col_md = "12";
          }
        });
      } else {
        that.form.segments.forEach((seg) => {
          seg.seg_card_col_md = "12";
        });
      }
      
    },
    testSegArray(){
      console.log(this.form.segments)
    },
    addSegment(){
      var that = this;
      var initializedSegment = that.initilizeAddedSegment({});
      that.form.segments.push(initializedSegment);
      that.determineSegmentsCardsColSize();
    },
    removeSegment(setId){
      let segIndexToRemove = this.form.segments.findIndex(s => s.seg_temp_id === setId);
      if(segIndexToRemove >= 0){
        this.form.segments.splice(segIndexToRemove, 1);
        this.determineSegmentsCardsColSize();
      }
    },
    async getTechProductsData(savedTechProductsPoints = []){
      var that = this;
      var method = 'GET';
      var pathTemplate = '/tech-products';
      var additionalParams ={};
      var pathParams = {};
      var userDatas = [];
      var that = this;
      apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
      .then(function(results){
        var data = results["data"]["data"];
        that.allTechs = data;
        that.mainTechs = data.filter(item => {return item.type === 'main'});
        that.subTechs = data.filter(item => {return item.type === 'sub'});
        
        // initialize and add a single segment
        that.addSegment();
      }).catch( function(error){
        that.showErrorMsg({message: 'Cannot load the tech Products from endpoint: ' + error.message});
      });
    },
    initilizeAddedSegment(seg){
      var initializedSeg = {};
      initializedSeg['seg_wallet']       = this.setNullValue(seg.seg_wallet, null);
      initializedSeg['seg_temp_id']      = this.setNullValue(seg.seg_temp_id, uuid.v4());
      initializedSeg['seg_name']         = this.setNullValue(seg.seg_name, '');
      initializedSeg['seg_alias']        = this.setNullValue(seg.seg_alias, '');
      initializedSeg['seg_description']  = this.setNullValue(seg.seg_description, '');
      initializedSeg['seg_published']    = this.setNullValue(seg.seg_published, true);
      initializedSeg['seg_segCount']     = this.setNullValue(seg.seg_segCount, 0);
      initializedSeg['seg_segCountIsGreaterThanWalletAvailableCount'] = this.setNullValue(seg.seg_segCountIsGreaterThanWalletAvailableCount, false);
      initializedSeg['isWalletSegNameAlreadyTaken'] = this.setNullValue(seg.isWalletSegNameAlreadyTaken, false);
      initializedSeg['seg_segPointsValue'] = this.setNullValue(seg.seg_segPointsValue, 0);
      initializedSeg['seg_mainTechnologies'] = this.setNullValue(seg.seg_mainTechnologies, JSON.parse(JSON.stringify(this.mainTechs)));
      initializedSeg['seg_subTechnologies']  = this.setNullValue(seg.seg_subTechnologies, JSON.parse(JSON.stringify(this.subTechs)));
      initializedSeg['seg_active']    = this.setNullValue(seg.seg_active, true);

      initializedSeg['seg_mainTechnologies'].forEach((mainTech) =>{
        mainTech.checked = false;
        mainTech.disabled = false;
      });
      initializedSeg['seg_subTechnologies'].forEach((subTech) =>{
        subTech.checked = false;
        subTech.disabled = true;
      });

      initializedSeg['seg_chosenMainTechnologies'] = [];
      initializedSeg['seg_chosenSubTechnologies'] = [];
      initializedSeg['seg_card_col_md'] = "12";

      initializedSeg['main_tech_selection_status'] = this.setNullValue(seg.main_tech_selection_status, 'not_one_main_tech_checked');

      return initializedSeg;
    },
    setNullValue(fieldValue, nullValue){
      return (fieldValue != null && fieldValue != undefined) ? fieldValue : nullValue;
    },
    getQrTechUpdateUpdateScenariosToPassToBackend(){
      var that = this;
      let updateQR_ProtectCodeParams = {
        walletSegmentId: that.walletSeg_DBData.id,
        newMode: false,
        startingCountInfo:{
          startingCount: 0,
          increaseCount: 0
        },
        updateMode: false,
        updateModeParams: {
          updateQRIncreaseCount: false,
          updateQRAddProtectCode: false,
          updateQRIncreaseCountWithProtectCode: false
        },
        companyId: that.walletSeg_DBData.company_id,
      }

      // Original Data from DB
      let originalWalletSegmentThatUsesQRTech = !!that.walletSeg_DBData.chosenMainTechsAndConfigs.find(chosenMainTech => chosenMainTech.main_techProductName == 'qr' && 
                                            chosenMainTech.tech_configs.generate_qr == true );
      // Updated in UI
      let objSegment = that.form.segments[0];
      let walletSegmentAtUIThatUsesQRTech = !!objSegment.seg_chosenMainTechnologies.find(chosenMainTech => chosenMainTech.main_techProductName == 'qr' && 
                                            chosenMainTech.tech_configs.generate_qr == true );

      if(originalWalletSegmentThatUsesQRTech && walletSegmentAtUIThatUsesQRTech){
        // Okay, this is qr tech
        
        // Starting Scenrio 1 of segCount increasing in UI
        if(parseInt(objSegment.seg_segCount) > parseInt(that.walletSeg_DBData.segmentCount)) {
          updateQR_ProtectCodeParams.updateMode = true;
          
           // Scenario 1.1
           // segCount increased in UI, protectCode Already enabled in saved data -> result: updateQRIncreaseCount = true
          let originalSegmentHasProtectCodeTech_Enabled = !!that.walletSeg_DBData.chosenSubTechsAndConfigs.find(chosenSubTech => chosenSubTech.sub_techProductName == 'protect_code');
          if(originalSegmentHasProtectCodeTech_Enabled){
            updateQR_ProtectCodeParams.startingCountInfo.startingCount = parseInt(that.walletSeg_DBData.segmentCount);
            updateQR_ProtectCodeParams.startingCountInfo.increaseCount = parseInt(objSegment.seg_segCount) - parseInt(that.walletSeg_DBData.segmentCount);

            updateQR_ProtectCodeParams.updateModeParams.updateQRIncreaseCount = true;
            updateQR_ProtectCodeParams.updateModeParams.updateQRIncreaseCountWithProtectCode = false;
            updateQR_ProtectCodeParams.updateModeParams.updateQRAddProtectCode = false;
          }

          // Scenario 1.2
          // segCount increased in UI, protectCode disable in saved data, enable protectCode in UI -> result: updateQRIncreaseCountWithProtectCode = true
          let walletSegmentAtUI_EnableProtectCode = !!objSegment.seg_chosenSubTechnologies.find(chosenSubTech => chosenSubTech.sub_techProductName == 'protect_code');
          if(!originalSegmentHasProtectCodeTech_Enabled && walletSegmentAtUI_EnableProtectCode){
            updateQR_ProtectCodeParams.startingCountInfo.startingCount = 0;
            updateQR_ProtectCodeParams.startingCountInfo.increaseCount = parseInt(objSegment.seg_segCount);

            updateQR_ProtectCodeParams.updateModeParams.updateQRIncreaseCountWithProtectCode = true;
            updateQR_ProtectCodeParams.updateModeParams.updateQRIncreaseCount = false;
            updateQR_ProtectCodeParams.updateModeParams.updateQRAddProtectCode = false;
          }

          // Scenario 1.3
          // segCount increased in UI, protectCode disable in saved data, protectCode in UI disable -> result: updateQRIncreaseCount = true
          if(!originalSegmentHasProtectCodeTech_Enabled && !walletSegmentAtUI_EnableProtectCode){
            updateQR_ProtectCodeParams.startingCountInfo.startingCount = parseInt(that.walletSeg_DBData.segmentCount);
            updateQR_ProtectCodeParams.startingCountInfo.increaseCount = parseInt(objSegment.seg_segCount) - parseInt(that.walletSeg_DBData.segmentCount);

            updateQR_ProtectCodeParams.updateModeParams.updateQRIncreaseCount = true;
            updateQR_ProtectCodeParams.updateModeParams.updateQRAddProtectCode = false;
            updateQR_ProtectCodeParams.updateModeParams.updateQRIncreaseCountWithProtectCode = false;
          }
        }
        // Starting Scenrio 2 of segCount still the same in UI as original saved data
        if(parseInt(objSegment.seg_segCount) == parseInt(that.walletSeg_DBData.segmentCount)) {

          // Scenario 2.1
          // segCount not increased in UI, protectCode disable in saved data, enable protectCode in UI -> result: updateQRAddProtectCode = true
          let originalSegmentHasProtectCodeTech_Enabled = !!that.walletSeg_DBData.chosenSubTechsAndConfigs.find(chosenSubTech => chosenSubTech.sub_techProductName == 'protect_code');
          let walletSegmentAtUI_EnableProtectCode = !!objSegment.seg_chosenSubTechnologies.find(chosenSubTech => chosenSubTech.sub_techProductName == 'protect_code');
          if(!originalSegmentHasProtectCodeTech_Enabled && walletSegmentAtUI_EnableProtectCode){
            updateQR_ProtectCodeParams.updateMode = true;
            updateQR_ProtectCodeParams.startingCountInfo.startingCount = 0;
            updateQR_ProtectCodeParams.startingCountInfo.increaseCount = parseInt(objSegment.seg_segCount);

            updateQR_ProtectCodeParams.updateModeParams.updateQRAddProtectCode = true;
            updateQR_ProtectCodeParams.updateModeParams.updateQRIncreaseCount = false;
            updateQR_ProtectCodeParams.updateModeParams.updateQRIncreaseCountWithProtectCode = false;
          }
        }
      }
      
      return updateQR_ProtectCodeParams;
    },
    post: async function(option){
      var that = this;
      const validationResult = this.$validator.validateAll().then(  (result) => {
        if(result){
          // Iterate the segments to validate wallet segment counts are not greater than the Real Wallet counts
          that.walletSegmentsCountValidationPass().then(validatationPass => {
            console.log("validatationPass: " + validatationPass);
            if(!validatationPass){
              console.log('Validation Fails');
              return;
            } else {
              console.log('Validation Pass');
              this.showErrorAlert = false;

              console.log((!that.walletSegmentUpdateMode) ? "Saving Wallet Segment info to DB" : "Updating Wallet Segment info to DB");
             
              // Save wallet segment info to db
              var body = (!that.walletSegmentUpdateMode) ? {
                walletSegments: that.form.segments,
                createdBy: that.loginUserInfo.login_username,
              } : {
                walletSegment: that.form.segments[0],
                updateBy: that.loginUserInfo.login_username,
                updateQR_ProtectCodeParams: (that.walletSeg_DBData != null && that.walletSeg_DBData != undefined) ? 
                                             that.getQrTechUpdateUpdateScenariosToPassToBackend() : null
              };

              this.$refs.form.openModal();
              if(that.walletSegmentUpdateMode){
                that.changeModalContent(
                  "loading",
                  "Updating...",
                  "Updating Wallet Segment(s) Info"
                );
              }else{
                that.changeModalContent(
                  "loading",
                  "Saving...",
                  "Saving Wallet Segment(s) Info"
                );
              }
              
              // Do POST to API insert into Database
              var method = (!that.walletSegmentUpdateMode) ? 'POST' : 'PUT';
              var pathTemplate = (!that.walletSegmentUpdateMode) ? '/wallet-segments' : '/wallet-segments/' + that.page_wallet_segment_id;
              var additionalParams ={
              };
              var pathParams = {
              };

              apigClient
              .invokeApi(pathParams, pathTemplate, method, additionalParams, body)
                .then(function(result){
                  if(result.data.status){
                    console.log((that.walletSegmentUpdateMode) ? 'updated wallet segment' : 'created new wallet segments ');
                    if(that.walletSegmentUpdateMode){
                      //that.showSuccessMsgUpdate();
                      that.changeModalContent(
                        "success",
                        "Updated success!",
                        "The Wallet Segment data has been updated"
                      );
                    }else{
                      // that.showSuccessMsgCreate();
                      that.changeModalContent(
                        "success",
                        "Saved success!",
                        "The Wallet Segment data has been saved"
                      ); 
                    }
                    if ( option == "andClose" ){
                      console.log('option andClose');
                      setTimeout(() => {
                        that.$router.push({ path: '/wallet-segments/list' })
                      }, 2000)
                    } 
                  }else{
                    console.log('Error From API Endpoint: ' + result.data.message);
                    // that.showErrorMsg();
                    that.changeModalContent(
                      "error",
                      "Error Occured!",
                      "Error From API Endpoint: " + result.data.message
                    );
                  }
                }).catch( function(result){
                  console.log('invokeAPI Error: ' + result);
                  // that.showErrorMsg();
                  that.changeModalContent(
                      "error",
                      "Error Occured!",
                      "Error From API Endpoint: " + result.message
                    );
                });
            }
          })
          
        } else{
          console.log('Validation Fails');
          // let nameAlreadyTaken_Segs = that.form.segments.filter(seg=>seg.isWalletSegNameAlreadyTaken);
          // if(nameAlreadyTaken_Segs){
          //   nameAlreadyTaken_Segs.forEach((seg)=>{
          //     seg.isWalletSegNameAlreadyTaken=false;
          //   });
          // }
          this.errorMsg = '<p><b>Validation Failed, Please correct the following errors.</b></p>';
          this.showErrorAlert = true;
        }
      });
    },
    walletSegmentsCountValidationPass: async function (){
      var that = this;
      let oneOfWalletSegCountIsGreaterThan_WalletCount = false;
      let headingErrorMsg = '<p><b>Validation Failed, Please correct the following errors.</b></p>';
      let bodyErrorMsg = '';

      if(!that.walletSegmentUpdateMode && that.form.segments.length>=1){
        let checkWalletSegNamesResult = await that.checkWalletSegNamesAreAlreadyTaken();
        let nameAlreadyTaken_Segs = that.form.segments.filter(seg=>seg.isWalletSegNameAlreadyTaken);
        if(checkWalletSegNamesResult=='error'){
          return false;
        }else if(nameAlreadyTaken_Segs.length>=1){
          let segNames = nameAlreadyTaken_Segs.map(seg=>{
            return seg.seg_name;
          });
          segNames=Array.from(new Set(segNames));
          bodyErrorMsg = "<p> Segment Name(s) : ("+ segNames.join(", ") +") are already taken. Please choose others </p>";
          that.errorMsg = headingErrorMsg + " " + bodyErrorMsg;
          that.showErrorAlert = true;
          return false;
        }
      }

      // Firstly, if there is a segment that count is greater the wallet available count, we will consider validation failed
      let segmentThatCountGreaterThan_WalletAvailableCount = that.form.segments.find(s=> s.seg_segCountIsGreaterThanWalletAvailableCount === true)
      if(segmentThatCountGreaterThan_WalletAvailableCount != null){
        that.errorMsg = headingErrorMsg + " " + bodyErrorMsg;
        that.showErrorAlert = true;
        return false;
      }

      // Let's validate for update mode
      // Update mode, validate not to let decrease the previous segment count
      if(that.walletSegmentUpdateMode && that.walletSeg_DBData != null && that.walletSeg_DBData != undefined){
        let segment = that.form.segments[0];
        if(parseInt(segment.seg_segCount) < parseInt(that.walletSeg_DBData.segmentCount)){
          that.updateCountIsLessThanOriginalSegCount = true;
          that.updateCountIsLessThanOriginalSegCount_Msg = "Value should not be less than Original Segment Count (" + that.walletSeg_DBData.segmentCount + ")";
          that.errorMsg = headingErrorMsg + " " + bodyErrorMsg;
          that.showErrorAlert = true;
          return false;
        } else{
          that.updateCountIsLessThanOriginalSegCount = false;
          that.updateCountIsLessThanOriginalSegCount_Msg = "";
        }
      }
      
      // Secondly, validate wallet count with segments counts if two or more segments are using the same wallet.
      that.existingWallets.forEach((wallet, walletIndex) => {
        let segments = that.form.segments.filter(s=> s.seg_wallet.value === wallet.value);
        let totalSegmentCounts = 0;
        let segmentsNumberToCheck = [];
        if(segments.length){
          segments.forEach((seg, segIndex) => {
            if(parseInt(seg.seg_segCount) > 0){
              totalSegmentCounts = totalSegmentCounts + parseInt(seg.seg_segCount);

              let segmentIndexInWholeSegmentsList = that.form.segments.findIndex(s=> s.seg_temp_id === seg.seg_temp_id);
              segmentsNumberToCheck.push(segmentIndexInWholeSegmentsList + 1);
            }
          });

          if(totalSegmentCounts > 0){
            if(parseInt(totalSegmentCounts) > parseInt(wallet.availableCountForNewWalletSegment)){
              bodyErrorMsg = bodyErrorMsg + 
                " <p>- Total Segment Count of Segment Numbers("+ segmentsNumberToCheck.join(", ") + 
                ") is <b>" + totalSegmentCounts + "</b> and It is greater than its selected wallet(" + wallet.walletName + ") Available Count <b>"+ 
                wallet.availableCountForNewWalletSegment +
                "</b> </p>"
            }
          }
        }
      });

      // Validate only protectCode tech needs at least one qr at other segment
      let thereIsSegmentThatHas_ProtectCodeTech_Selected = false;
      for(let i=0; i< that.form.segments.length; i++){
        let seg = that.form.segments[i];
        let qrTech_NotGenerateQR = seg.seg_chosenMainTechnologies.find(chosenMainTech => chosenMainTech.main_techProductName == 'qr' && chosenMainTech.tech_configs.generate_qr == false);
        if(qrTech_NotGenerateQR){
          let protectCodeTech_SelectedTech = seg.seg_chosenSubTechnologies.find(chosenSubTech => chosenSubTech.sub_techProductName == 'protect_code');
          if(protectCodeTech_SelectedTech){
            thereIsSegmentThatHas_ProtectCodeTech_Selected = true;
            break;
          }
        }
      }
      if(thereIsSegmentThatHas_ProtectCodeTech_Selected){
        // -- Call API to validate by passing that.form.segments
        console.log('Detected ONly protect code chosen segment, passing segments to api to test with db');

        // Do POST to API insert into Database
        var method = 'POST';
        var pathTemplate = '/wallet-segments/validate';
        var additionalParams ={
        };
        var pathParams = {
        };
        var body = {
          walletSegments: that.form.segments
        };
        return await apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams, body)
          .then(function(result){
            if(result.data.status){
              console.log('Validated wallet segments returned from api');
              console.log(result["data"]["data"]);
              
              var segmentsValidatedResult = result["data"]["data"];
              let errorMsgFromAPI = "";

              // Get the error messagess from api
              segmentsValidatedResult.forEach((segValidatedReult) => {
                if(segValidatedReult.needOne_QRSegmentToAddInUI){
                  errorMsgFromAPI = errorMsgFromAPI + segValidatedReult.msg;
                }
              });

              // Append the errorMsg From API to bodyErrorMsg
              if(errorMsgFromAPI !=''){
                bodyErrorMsg = bodyErrorMsg + errorMsgFromAPI;
              }
              if(bodyErrorMsg.length > 0){
                that.errorMsg = headingErrorMsg + " " + bodyErrorMsg;
                that.showErrorAlert = true;
                return false;
              }else {
                return true;
              }  
            } else {
              console.log('Error From API Endpoint: ' + result.data.message);
              // that.showErrorMsg();
              that.changeModalContent(
                "error",
                "Error Occured!",
                "Error From API Endpoint: " + result.data.message
              );
              return false;
            }
          }).catch( function(result){
            console.log('invokeAPI Error: ' + result);
            // that.showErrorMsg();
            that.changeModalContent(
              "error",
              "Error Occured!",
              "Error From API Endpoint: " + result
            );
            return false;
          });
      } else{
        if(bodyErrorMsg.length > 0){
          that.errorMsg = headingErrorMsg + " " + bodyErrorMsg;
          that.showErrorAlert = true;
          return false;
        }
        return true;
      }
    },
    changeModalContent(status = null, title = null, message = null) {
      let that = this;
      that.$refs.form.status = status ? status : that.$refs.form.status;
      that.$refs.form.title = title ? title : that.$refs.form.title;
      that.$refs.form.message = message ? message : that.$refs.form.message;
    },
    routerBack(){
      this.$router.go(-1);
    },
    onSubmit() {
      if (this.validate()) {
        this.$nextTick(() => {
          // submit
          // console.log('submit:', this.formStr)
          this.submitted = true
          this.feedBack = 'info'
        })
      }
    },
    onReset() {
      // Reset validation
      this.form = Object.assign({}, formShape)
      this.submitted = false
      this.$nextTick(() => {
        this.$v.$reset()
        this.feedBack = 'secondary'
      })
    },
    
    validate() {
      this.isValid();
    },
  },
  notifications: {
    showSuccessMsgCreate: {
      type: VueNotifications.types.success,
      title: 'Operation successfull!',
      message: 'The wallet segment(s) has been created'
    },
    showSuccessMsgUpdate: {
      type: VueNotifications.types.success,
      title: 'Operation successfull!',
      message: 'The wallet segment has been updated'
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: 'Info',
      message: 'Here is some info for you'
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: 'Warning',
      message: 'That\'s the kind of warning'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: 'ERROR',
      message: 'Error! See console for additional error logs'
    },
    showErrorCognito: {
      type: VueNotifications.types.error,
      title: 'ERROR',
      message: 'This user cannot be authenticated, please make sure this user have been confirmed by email'
    }
  },
}
</script>

<style scoped>
  .btn.disabled {
    cursor: auto;
  }
  .custom-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .btn-group > .btn, .btn-group-vertical > .btn {
      border: 1px solid #a4acb5;
  }

  @media only screen and (max-width: 600px) {
    .custom-header{
      flex-direction: column;
      align-items: inherit;
    }

    .custom-header > div:first-child {
      margin-bottom: 10px;
    } 

  }
  .custom-cancel {
    border-radius: 0.25rem 0 0 0.25rem;
  }
  .sk-fading-circle .sk-circle {
    margin: 0 auto;
  }
  .sk-three-bounce {
    height: 40px;
  }

</style>

<style>
  #language {
    margin-top: 15px;
  }
  .custom-header{
    display: flex;
    justify-content: space-between;
  } 
  select {
    /* for Firefox */
    -moz-appearance: none;
    /* for Chrome */
    -webkit-appearance: none;
  }
  /* For IE10 */
  select::-ms-expand {
    display: none;
  }

  .resize-none{
    resize: none;
  }
  .margin-bottom-25{
    margin-bottom: 25px !important;
  }

  .tab-content{
    border: 0px !important;
  }
  .nav-tabs{
    border-bottom: 2px solid #c8ced3 !important;
  }
  .btnNextDetails{
    padding: 0.5rem 2rem !important;
    background-color: #35b4b9 !important;
    font-weight: bold !important;
    color: #fff !important;
  }
  .btnNextDetails:hover{
    background-color: #2da9ad !important;
    font-weight: bold !important;
    color: #fff !important;
  }
  .btnNextDetails:focus{
    background-color: #2da9ad !important;
    font-weight: bold !important;
    color: #fff !important;
  }
  .vue-input-tag-wrapper{
    border-radius: .25rem !important;
    -moz-appearance: none !important;
    -webkit-appearance: none !important;
  }
  .folder-invalid-border .dropdown-toggle{
    border-color:#f86c6b;
  }
  .is-valid-border{
    border-color:#4dbd74;
  }
  .color-red{
    color:red;
  }
  .form-group label.required:after {
    content: " *";
    color: #f86b4f;
  }
  .padding-left-0{
    padding-left: 0px !important;
  }
  .set-card .card-footer{
    background-color:transparent;
  }
  .set-card .card-footer button{
    float: right;
  }
  .set-card .card-footer .btn-outline-secondary{
    color:#000;
  }
  .color-black{
    color:#000 !important;
    font-weight: 100 !important;
  }
  .float-right{
    float: right;
  }
  .margin-left-10{
    margin-left: 10px !important;
  }
  .margin-top-10{
    margin-top:10px;
  }
  .tech-image{
    height:15px;
  }
  .padding-top-1{
    padding-top: 1px;
  }
  .techs-config .tab-content{
    background:transparent;
    width:300px;
  }
  .errorMsg p{
    margin:auto;
  }
  .count-info{
    background:#e0f3f8;
    overflow: hidden; 
    text-align: center;
  }
  .count-info span {
    color: #813838;
    display: inline-block;
    margin: auto;
    padding: 5px 10px;
  }
  
</style>